import { render } from "./ViewKalendar.vue?vue&type=template&id=3a572e62"
import script from "./ViewKalendar.vue?vue&type=script&lang=js"
export * from "./ViewKalendar.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__